// eslint-disable-next-line class-methods-use-this
export default class HubEdito {
    constructor() {
        this.templateInfos = {
            activeCategoryclass: 'hub-cat__list__item--current'
        };
    }

    // eslint-disable-next-line class-methods-use-this
    getTplDOM(dataToPopulateHTML, tplType = 'default') {
        const {
            path,
            picto,
            title,
            description,
            user,
            date,
            pageType
        } = dataToPopulateHTML;
        const pictoUrlExposeePublique = picto.replace('jcr:content', '_jcr_content');

        switch (tplType) {
            case 'LEXIQUE':
                return `<li data-card-item="true" class="pos-r ovh hub-card flex-xs-12 flex-md-6 flex-lg-4 card list__item--no-style hub-card--blue-bg hub-card--height20 clickable" data-click-target=".extended-link">
                            <div class="card__header hub-link__border--bottom ml2 mr2 pl0 pr0 pb1 pt2">
                                <a href="${path}.html" class="title title--xxs card__header__title extended-link" data-behavior-click="container-click">${title}</a>
                            </div>
                            <div class="card__content hub-card--text m2 pl0 pr0">${description}</div>
                        </li>`;
            case 'ACTU':
                return `<li data-card-item="true" class="ovh hub-card hub-card--height flex-xs-12 flex-md-6 flex-lg-4 card list__item--no-style hub-card--height32 clickable card--img-zoom" data-click-target=".extended-link">
                            <div class="hub-card__img-wrapper ovh">
                                <div class="card__header card__header--img card__header__img--zoom" style="background-image: url(${pictoUrlExposeePublique})"></div>
                            </div>
                            <div class="card__content p2">
                                <div class="card__content__title text--blue title--uppercase">${pageType}</div>
                                <div class="text text--xs text--bold text--gray-dimgray">Par ${user}, le ${date}</div>
                                <a href="${path}.html" class="text--gray-mine-shaft text text--bold tdn extended-link" data-behavior-click="container-click" title="${title}">${title}</a>
                            </div>
                        </li>`;
            default:
                return `<li data-card-item="true" class="ovh hub-card hub-card--height flex-xs-12 flex-md-6 flex-lg-4 card list__item--no-style hub-card--height32 clickable card--img-zoom" data-click-target=".extended-link">
                            <div class="hub-card__img-wrapper ovh">
                                <div class="card__header card__header--img card__header__img--zoom" style="background-image: url(${pictoUrlExposeePublique})"></div>
                            </div>
                            <div class="card__content p2">
                                    <div class="card__content__title text--blue title--uppercase">${pageType}</div>
                                    <a href="${path}.html" class="text--gray-mine-shaft text text--bold tdn extended-link" data-behavior-click="container-click" title="${title}">${title}</a>
                                </div>
                            </div>
                        </li>`;
        }
    }
}
